import './App.css';
import ArtCatalogForm from './components/ArtCatalogForm';
import logo from './logo.png';
import React, { useState, useEffect } from 'react';
import configData from './config.json';

function App() {

  const [isAuthenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState('');
  let username = '';
  let password = '';

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
      setAuthenticated(true);
    } else {
      if (!username) {
        username = prompt('Please enter your username:');
      }
      if (!password) {
        password = prompt('Please enter your password:');
      }

      if (username && password) {
        fetch(configData.apiBaseUrl + configData.loginUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username: username, password: password })
        })
          .then(response => response.json())
          .then(data => {
            if (data.access_token) {
              localStorage.setItem('token', data.access_token);
              setToken(data.access_token);
              setAuthenticated(true);
            } else {
              alert('Authentication Failed');
            }
          }).catch(error => {
            console.error('Authentication Failed:', error);
          });
      } else {
        alert('Authentication Required');
      }
    }
  }, [])

  return (
    <div>
      {isAuthenticated ?
        <div className="App">
          <header className="App-header">
            <div className="top-content">
              <img src={logo} alt="logo" className='App-logo' />
              <h2 className="App-title">Art Catalog Generator</h2>
            </div>
            <ArtCatalogForm />
          </header>
        </div>
        :
        <div>Please log in to continue.</div>
      }
    </div>
  );
}

export default App;